import React from 'react';
import SubscribedComponent from '../components/subscribed_component.js';
import { Link } from 'react-router-dom'
import { Table } from 'reactstrap';

const get = (object, path) =>
  path.reduce((nestedObj, pathPart) =>
    (nestedObj && nestedObj[pathPart]) ? nestedObj[pathPart] : null, object)

class Account extends SubscribedComponent {
  render() {
    const LayoutWrapper = this.props.layout

    const name             = get(this.state, ['claims','customer','info','full_name'])
    const email            = get(this.state, ['claims','customer','email'])
    const sportPreference  = get(this.state, ['claims','customer','info','prefered_sport'])
    const subscriptionArea = this.subscriptionArea()

    return (
      <LayoutWrapper>
        <div className="page">
          <h2>My Account</h2>
          <hr />

          <dl className="row">
            <dt className="col-sm-3">Name</dt>
            <dd className="col-sm-9">{name}</dd>
            <dt className="col-sm-3">Email</dt>
            <dd className="col-sm-9">{email}</dd>
            <dt className="col-sm-3">Sport Preference</dt>
            <dd className="col-sm-9">{sportPreference}</dd>
          </dl>

          {subscriptionArea}
        </div>
      </LayoutWrapper>
    );
  }

  subscriptionArea() {
    const {permissions, claims} = this.state
    const {subscription_expirations} = claims

    if (permissions.includes('wreck_details') && !!subscription_expirations) {
      const subscriptionCodes = Object.keys(subscription_expirations)

      return (
        <div>
          <hr />
          <h4>Subscriptions</h4>
          <Table responsive>
            <thead>
              <tr>
                <th>Wreck Pack</th>
                <th>Active</th>
                <th>Renewal Date</th>
              </tr>
            </thead>
            <tbody>
              {
                subscriptionCodes.map((subscriptionCode) => {
                  let expiration = subscription_expirations[subscriptionCode]
                  let active = new Date() < Date.parse(expiration)
                  return (
                    <tr>
                      <th scope="row">{subscriptionCode}</th>
                      <td>{ active ? 'True' : 'False' }</td>
                      <td>{expiration}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </div>
      )
    } else {
      return (
        <div>
          <Link className="btn btn-secondary" to="/buy">Buy Premium</Link>
        </div>
      )
    }
  }
}

export default Account;



// WEBPACK FOOTER //
// ./src/pages/account.js